<template>
	<Chip
		class="pointer-events-none"
		:size="isXS ? 'xs' : 's'"
		:class="showBorder ? 'border-s border-white' : 'border-none'"
	>
		<div class="d-flex gap-1 align-center">
			<Icon
				class="d-flex align-center overflow-hidden icon text-primary-800"
				style="height: 20px; width: 20px"
				icon="certificateBadge"
			/>
			<p v-if="!isXS || showTextMobile" class="text-label-s font-weight-bold text-primary-800">
				{{ $t('common_tag_Recommended') }}
			</p>
		</div>
	</Chip>
</template>

<script setup lang="ts">
	interface Props {
		isXS: boolean
		showTextMobile?: boolean
		showBorder?: boolean
	}

	withDefaults(defineProps<Props>(), {
		showBorder: true,
	})
</script>
